// Axios
import { AxiosResponse } from "axios";
import { _axios } from "../../Base_Axios_Config/_axios";
// Axios

// Models
import { I_Message, I_TaskDetail } from "../../../Models/interfaces";
// Models

export const getTaskDetailsByTaskIdInTasksService = async (
  userToken: string,
  taskId: string
): Promise<
  AxiosResponse<{
    error: number;
    messages: I_Message[];
    result: I_TaskDetail;
  }>
> => {
  return _axios.get(`/tasks/${taskId}/detail`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
